enum AnimalsAndEventsTabsKeys {
  animals = 'animals',
  group_animals = 'group_animals',
  events = 'events',
}
export default AnimalsAndEventsTabsKeys;
